module.exports = __webpack_public_path__ + "img/menu-button-of-three-lines.1a266c1a.svg";